import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { StringListEditor, ObjectListEditor } from "./widgets.jsx";

// Friendly editor for the `antibiotic_guide` collection.

const REGIMEN_COLUMNS = [
  { key: "drug", label: "Drug", span: "md:col-span-3" },
  { key: "dose", label: "Dose", span: "md:col-span-4" },
  { key: "duration", label: "Duration", span: "md:col-span-2" },
  { key: "notes", label: "Notes", span: "md:col-span-3" },
];

export default function AntibioticGuideForm({ value, onChange }) {
  const doc = value || {};
  const set = (k, v) => onChange({ ...doc, [k]: v });
  return (
    <div className="space-y-4" data-testid="antibiotic-guide-form">
      <div className="grid md:grid-cols-3 gap-3">
        <div>
          <Label className="text-xs">Condition</Label>
          <Input value={doc.condition ?? ""} onChange={(e) => set("condition", e.target.value)} className="mt-1 text-sm" data-testid="abxform-condition" />
        </div>
        <div>
          <Label className="text-xs">Category</Label>
          <Input value={doc.category ?? ""} onChange={(e) => set("category", e.target.value)} className="mt-1 text-sm" data-testid="abxform-category" />
        </div>
        <div>
          <Label className="text-xs">Setting</Label>
          <Input value={doc.setting ?? ""} onChange={(e) => set("setting", e.target.value)} placeholder="Outpatient / Inpatient" className="mt-1 text-sm" data-testid="abxform-setting" />
        </div>
      </div>

      <div>
        <Label className="text-xs font-semibold text-[#111827]">First-line regimen</Label>
        <div className="mt-1">
          <ObjectListEditor value={doc.first_line} onChange={(v) => set("first_line", v)} columns={REGIMEN_COLUMNS} testid="abxform-firstline" addLabel="Add first-line drug" />
        </div>
      </div>

      <div>
        <Label className="text-xs font-semibold text-[#111827]">Alternative regimen</Label>
        <div className="mt-1">
          <ObjectListEditor value={doc.alternative} onChange={(v) => set("alternative", v)} columns={REGIMEN_COLUMNS} testid="abxform-alt" addLabel="Add alternative drug" />
        </div>
      </div>

      <div>
        <Label className="text-xs">Key notes</Label>
        <Textarea value={doc.key_notes ?? ""} onChange={(e) => set("key_notes", e.target.value)} rows={2} className="mt-1 text-sm" data-testid="abxform-keynotes" />
      </div>

      <div>
        <Label className="text-xs">In pregnancy</Label>
        <Textarea value={doc.pregnancy ?? ""} onChange={(e) => set("pregnancy", e.target.value)} rows={2} className="mt-1 text-sm" data-testid="abxform-pregnancy" />
      </div>

      <div>
        <Label className="text-xs">Red flags</Label>
        <div className="mt-1">
          <StringListEditor value={doc.red_flags} onChange={(v) => set("red_flags", v)} placeholder="Add a red flag…" testid="abxform-redflags" />
        </div>
      </div>
      <p className="text-[11px] text-slate-500 px-1">Saving locks this guide from the periodic sync. Other fields are preserved untouched.</p>
    </div>
  );
}
